/**
 * Navigation Service
 * Handles API calls for tracking last visited page per user per project
 */

import { axiosInstance } from '@core/config/axios.config';

export interface LastVisitedResponse {
  project_id: string;
  last_visited_url: string;
  visited_at: string;
}

class NavigationService {
  /**
   * Save the user's last visited URL for a project
   */
  async saveLastVisited(projectId: string, lastVisitedUrl: string): Promise<void> {
    try {
      await axiosInstance.put(`/projects/${projectId}/last-visited`, {
        last_visited_url: lastVisitedUrl,
      });
    } catch {
      // Fire-and-forget — silently ignore errors
    }
  }

  /**
   * Get the user's last visited URL for a project
   * Returns null if no record exists (404)
   */
  async getLastVisited(projectId: string): Promise<LastVisitedResponse | null> {
    try {
      const response = await axiosInstance.get(`/projects/${projectId}/last-visited`);
      return response?.data?.data || response?.data;
    } catch {
      return null;
    }
  }
}

export const navigationService = new NavigationService();
